import {defineStyle} from '@chakra-ui/styled-system';

import {defineGraphCSSVars} from './helpers';

const {gap: $gap, border: $border} = defineGraphCSSVars(`control_group`, [`gap`, `border`]);

// Those are defined on the top level component
export const controlsCssVars = {
  [$gap.variable]: `space.0`,
  [$border.variable]: `borders.none`,
};

export const controlGroupStyle = defineStyle(({orientation}) => ({
  display: `flex`,
  flexDirection: orientation === `horizontal` ? `row` : `column`,
  [`& .react-flow__controls-button`]: {
    _first: {
      borderBottomRightRadius: `0`,
      borderBottomLeftRadius: `0`,
    },
    [`&:not(:first-of-type):not(:last-of-type)`]: {
      borderRadius: `0`,
    },
    _last: {
      borderTopRightRadius: `0`,
      borderTopLeftRadius: `0`,
    },
  },
}));
